"use client";

import Image from "next/image";
import Link from "next/link";

import CornerMenu from "../magazine-header/corner-menu";

export default function MagazineMobileHeader() {
  return (
    <>
      <header
        className="fixed top-0 left-0 right-0 bg-background border-b z-50 md:hidden"
        suppressHydrationWarning
      >
        <div className="container flex justify-between items-center w-full py-4">
          <Link href="/magazine">
            <Image
              src="/logo-official-black.png"
              alt="goodali logo"
              width={200}
              height={20}
              className="object-contain"
            />
          </Link>
          <CornerMenu />
        </div>
      </header>
      <div style={{ height: 56 }} className="md:hidden" />
    </>
  );
}
